import { render, staticRenderFns } from "./OptionListItem.vue?vue&type=template&id=2ca1e487&scoped=true&"
import script from "./OptionListItem.vue?vue&type=script&lang=js&"
export * from "./OptionListItem.vue?vue&type=script&lang=js&"
import style0 from "./OptionListItem.vue?vue&type=style&index=0&id=2ca1e487&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca1e487",
  null
  
)

export default component.exports